import { BSkeletonTable } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBSkeletonTable = createEgBootstrapProxy(
  "EgBSkeletonTable",
  BSkeletonTable
);
